import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { ContractType } from "../../models/contract-type.model";

export namespace ContractTypeActions {

  @logDispatcher
  export class GetContractTypes {
    static readonly type = '[ContractType] GetContractTypes';
    constructor() { }
  }

  @logDispatcher
  export class GetContractTypesSuccess {
    static readonly type = '[ContractType] GetContractTypesSuccess';
    constructor(public contractTypes: ContractType[]) { }
  }

  @logDispatcher
  export class GetContractTypesFail {
    static readonly type = '[ContractType] GetContractTypesFail';
    constructor(public error: any) { }
  }
}
